export default {
  首页: "Start",
  资产: "Verméigen",
  币币: "Spot",
  快捷买币: "Schnell Krypto kafen",
  "支持多种方式购买，购买更简单":
    "Kaaft einfach mat verschiddene Bezuelmethoden",
  语言设置: "Sproochastellungen",
  确认恢复: "Restauratioun bestätegen",
  "输入邮箱，方便我们联系您":
    "Gitt Är E-Mail Adress an, fir datt mir Iech kontaktéiere kënnen",
  划转: "Transferéieren",
  行情: "Maart",
  "24H成交": "24h Volumen",
  累计收益: "Gesamt Rendement",
  充值时间: "Depositioun Datum",
  到期时间: "Verfalldatum",
  数量: "Quantitéit",
  操作: "Aktioun",
  资产信息: "Verméigens Informatiounen",
  复制地址: "Adress kopéieren",
  链名称: "Blockchain Numm",
  充值地址: "Depositioun Adress",
  收款地址: "Empfängsadress",
  账单: "Rechnung",
  提现金额: "Ausbezuele Betrag",
  接收地址: "Empfängsadress",
  交易密码: "Handelspasswuert",
  提现全部: "Alles ausbezuelen",
  保存图片: "Bild späicheren",
  输入您的交易密码: "Gitt Äert Handelspasswuert an",
  确定: "Bestätegen",
  地址: "Adress",
  注册时间: "Registréierungsdatum",
  取消: "Ofbriechen",
  是否划转: "Transferéieren?",
  登录: "Aloggen",
  我的地址: "Meng Adressen",
  登录密码和交易密码: "Login- an Handelspasswuert",
  注册: "Registréieren",
  密码: "Passwuert",
  设置密码: "Passwuert astellen",
  重复密码: "Passwuert widderhuelen",
  新密码: "Neit Passwuert",
  确认新密码: "Neit Passwuert bestätegen",
  充值: "Deposéieren",
  充值货币: "Wärung deposéieren",
  合约账户充值: "Futures Kont deposéieren",
  账户充值: "Kont deposéieren",
  其他: "Aner",
  我的邀请码: "Meng Invitatiounscode",
  提现: "Ausbezuelen",
  客服: "Clientë Service",
  持有详情: "Detailer vum Besëtz",
  请输入内容: "Gidd Inhalt an",
  邀请好友来领取奖励: "Lued Frënn an a kréi Belounungen",
  复制链接: "Link kopéieren",
  重复设置新的密码: "Neit Passwuert widderhuelen",
  保存: "Späicheren",
  我的: "Meng",
  "邮箱/手机号": "E-Mail / Mobil Nummer",
  备注: "Bemierkung",
  地址管理: "Adress Gestioun",
  我的团队: "Meng Team",
  联系我们: "Kontaktéiert eis",
  竭诚为您服务: "Mir stinn fir Iech prett",
  提取收益: "Rendement ausbezuelen",
  带给我的收益: "Rendement generéiert",
  添加: "Derbäisetzen",
  名称: "Numm",
  添加地址: "Adress derbäisetzen",
  修改地址: "Adress änneren",
  可提现: "Ausbezuelbar",
  安全中心: "Sécherheetszentrum",
  收益划转: "Rendement transferéieren",
  通知中心: "Notifikatiounen",
  "累计收益:": "Gesamt Rendement:",
  注册用户: "Registréiert Benotzer",
  奖励规则: "Belounungsregelen",
  帮助反馈: "Hëllef & Feedback",
  邀请好友: "Frënn alueden",
  恢复身份: "Identitéit restauréieren",
  选择语言: "Sprooch wielen",
  设置新的密码: "Neit Passwuert astellen",
  暂无活动: "Keng aktiv Aktiounen",
  "月增长量(+)": "Mountleche Wuesstum (+)",
  可提取: "Ausbezuelbar",
  反馈类型: "Feedback Typ",
  赠送: "Cadeau",
  已经复制: "Kopéiert",
  保存成功: "Erfollegräich gespäichert",
  划转成功: "Transfert erfollegräich",
  过期: "Verfall",
  提交成功: "Erfollegräich agereecht",
  "服务器繁忙，稍后在试":
    "Server iwwerlaascht, probéiert spéider nach eng Kéier",
  全部: "All",
  一级: "Niveau 1",
  二级: "Niveau 2",
  三级: "Niveau 3",
  级: "Niveau",
  删除成功: "Erfollegräich geläscht",
  选择地址: "Adress wielen",
  不再提醒: "Net méi weisen",
  "最小充值金额：": "Minimum Depositounsbetrag:",
  选择币种: "Krypto Wärung wielen",
  输入投资金额: "Investitiounsbetrag aginn",
  输入账户密码: "Kont Passwuert aginn",
  投资: "Investéieren",
  订单编号: "Bestellnummer",
  投资周期: "Investitiounsdauer",
  投资资金: "Investéierte Betrag",
  投资时间: "Investitiounszäit",
  状态: "Status",
  投资中: "Aktiv",
  已到期: "Verfall",
  暂无数据: "Keng Daten",
  转入: "Transfert op",
  邮箱: "E-Mail",
  请输入邮箱: "E-Mail Adress aginn",
  请输入格式正确的邮箱: "Gitt eng gülteg E-Mail Adress an",
  请输入验证码: "Verifikatiounscode aginn",
  获取验证码: "Verifikatiounscode ufroen",
  请输入邀请码: "Invitatiounscode aginn",
  今天: "Haut",
  昨天: "Gëschter",
  最近七天: "Leschten 7 Deeg",
  邀请: "Alueden",
  购买数量: "Kaf Quantitéit",
  产品详情: "Produkt Detailer",
  币种: "Krypto Wärung",
  利息币种: "Rendement Wärung",
  理财类型: "Typ vu Finanzprodukt",
  产品费率: "Produkt Käschten",
  进行中: "Aktiv",
  每天: "All Dag",
  请输入搜索关键词: "Sichbegrëff aginn",
  通知: "Notifikatiounen",
  查看更多: "Méi gesinn",
  理财宝: "Finanzprodukter",
  周期: "Lafzäit",
  年利率: "Jährlechen Zënssaz (APY)",
  更多产品: "Méi Produkter",
  灵活存取: "Flexibel Spueren",
  稳定收益: "Stabilt Rendement",
  合约指南: "Futures Guide",
  资金划转出: "Ausgehenden Transfert",
  矿池收益: "Mining Belounung",
  提现手续费: "Ausbezuelkäschten",
  冻结资金: "Blockéiert Verméigen",
  解冻资金: "Blockéiert Verméigen fräiginn",
  闪兑支出: "Ausgab fir schnellen Austausch",
  闪兑收入: "Akomme vu schnellen Austausch",
  闪兑手续费: "Käschte fir schnellen Austausch",
  合约支出: "Ausgab Futures",
  合约收入: "Akomme Futures",
  输入的金额不可大于可用金额:
    "Betrag däerf net méi grouss sinn wéi de disponibele Betrag",
  全部兑换成功: "Kompletten Austausch erfollegräich",
  返回: "Zréck",
  查看历史: "Geschicht kucken",
  闪兑历史: "Geschicht vum schnellen Austausch",
  支付: "Bezuelen",
  获取: "Kréien",
  时间: "Zäit",
  手续费: "Transaktiounskäschten",
  折扣: "Rabatt",
  价格: "Präis",
  逐仓: "Isoléiert Marge",
  全仓: "Cross Marge",
  市价委托: "Maartorder",
  限价委托: "Limit Order",
  请输入本金: "Haaptbetrag aginn",
  请输入价格: "Präis aginn",
  "可做空/做多": "Short/Long méiglech",
  设置止盈止损: "Take-Profit / Stop-Loss setzen",
  止盈价: "Take-Profit Präis",
  止损价: "Stop-Loss Präis",
  成本: "Kaschtpräis",
  做多: "Long",
  做空: "Short",
  仓位信息: "Positiounsinformatiounen",
  一键平仓: "Positioun zoumaachen (een Klick)",
  永续: "Perpetual",
  浮动盈亏: "Onrealiséierte Gewënn/Verloscht",
  平仓: "Positioun zoumaachen",
  反向开仓: "Ëmgedréint Positioun opmaachen",
  一键撤销: "All annuléieren (een Klick)",
  倍杠杆: "x Hebel",
  执行价格: "Ausféierungspräis",
  委托数量: "Bestell Quantitéit",
  保证金: "Marge",
  成交价: "Ausféierungspräis",
  创建时间: "Erstellungszäit",
  撤销: "Annuléieren",
  合约市场: "Futures Maart",
  交易方向: "Handelsrichtung",
  委托价格: "Bestellpräis",
  委托金额: "Bestellbetrag",
  资金费率: "Finanzéierungszënssaz",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Periodesch Käschte bezuelt vu Long- a Short-Positiounen, all 8 Stonne verrechent.",
  "资金费率为正，多方向空方支付资金费用。":
    "Mat engem positive Finanzéierungszënssaz bezuelen Long-Positiounen u Short-Positiounen.",
  "资金费率为负，空方向多方支付资金费用。":
    "Mat engem negative Finanzéierungszënssaz bezuelen Short-Positiounen u Long-Positiounen.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Sidd Dir sécher datt Dir eng ëmgedréint Positioun wëllt opmaachen? Dëst keeft déi entgéintgesate Richtung vun Ärer aktueller Positioun.",
  "仓位止盈/止损": "Take-Profit / Stop-Loss fir Positioun",
  合约名称: "Futures Kontrakt",
  开仓价格: "Oppungspräis",
  指数价格: "Indexpräis",
  止盈设置: "Take-Profit Astellungen",
  请输入止盈价: "Take-Profit Präis aginn",
  "当指数价格触达*时，将会触发委托平仓":
    "Wann den Indexpräis * erreecht, gëtt eng Zoumaachungsbestellung ausgeléist.",
  预计盈亏: "Erwaarte Gewënn/Verloscht",
  当前仓位: "Aktuell Positioun",
  平仓金额: "Zoumaachungsbetrag",
  仓位模式: "Positiounsmodus",
  全仓模式: "Cross Marge Modus",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "Am Cross Marge Modus gëtt all disponibel Verméigen op Ärem Futures Kont als Marge benotzt. Liquidatioun geschitt wann de Verloscht Äert Gesamtverméigen iwwerschreift, a Dir verléiert all Är Marge a Positioun.",
  逐仓模式: "Isoléiert Marge Modus",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "E spezifesche Betrag u Marge gëtt enger Positioun zougewisen. Wann de Margeverloscht ënner dem Ënnerhaltsmargeniveau fält, gëtt d'Positioun liquidéiert. Dir kënnt d'Marge fir dës Positioun erhéijen oder reduzéieren.",
  "是否撤销？": "Bestellung annuléieren?",
  "是否一键撤销？": "All Bestellungen annuléieren?",
  "是否一键平仓？": "All Positiounen zoumaachen?",
  持仓保证金: "Marge fir aktuell Positioun",
  风险率: "Risikoprozentsaz",
  未实现盈亏: "Onrealiséierte Gewënn/Verloscht",
  可用保证金: "Disponibel Marge",
  净值: "Netto Wäert",
  账户余额: "Kontosaldo",
  合约计算器: "Futures Rechner",
  交易记录: "Transaktiounsgeschicht",
  "*倍杠杆": "*x Hebel",
  "平仓盈亏：": "Geschlossene Gewënn/Verloscht:",
  时间筛选: "Zäitfilter",
  仓位类型: "Positiounstyp",
  订单状态: "Bestellstatus",
  订单类型: "Bestelltyp",
  平仓价格: "Zoumaachungspräis",
  持仓数量: "Positiounsquantitéit",
  "手续费(%)": "Transaktiounskäschten (%)",
  平仓时间: "Zoumaachungszäit",
  平仓类型: "Zoumaachungstyp",
  手动平仓: "Manuell zougemaach",
  强制平仓: "Zwangsliquidatioun",
  近1天: "Leschten Dag",
  近7天: "Leschten 7 Deeg",
  近30天: "Leschten 30 Deeg",
  近180天: "Leschten 180 Deeg",
  持仓: "Oppositioun",
  已取消: "Annuléiert",
  分时: "Intradag",
  "24H额(USDT)": "24h Volumen (USDT)",
  "24H低": "24h Déifst",
  "24H量(BTC)": "24h Volumen (BTC)",
  "24H高": "24h Héichst",
  "10秒": "10 Sekonnen",
  "30秒": "30 Sekonnen",
  "1分": "1 Minutt",
  "3分": "3 Minutten",
  "5分": "5 Minutten",
  "30分": "30 Minutten",
  "1小时": "1 Stonn",
  "4小时": "4 Stonnen",
  "8小时": "8 Stonnen",
  "1天": "1 Dag",
  "1周": "1 Woch",
  "1月": "1 Mount",
  单向持仓: "Eenweg Positioun",
  杠杆: "Hebel",
  仓位: "Positioun",
  计算结果: "Resultat",
  盈亏: "Gewënn/Verloscht",
  收益率: "Rendement",
  计算结果仅供参考: "Resultat ass indikativ",
  成交后仓位大小: "Positiounsgréisst no Ausféierung",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Resultat ass indikativ, tatsächlech Resultater kënnen duerch Transaktiounskäschten ofwäichen.",
  目标价格: "Zilpräis",
  开始计算: "Berechnen",
  强平价格: "Liquidatiounspräis",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Iwwerpréift virum Depot suergfälteg d'Blockchain Numm. Falsch Depoter kënnen net réckgängeg gemaach ginn. De Minimum Depotbetrag ass *. Depoter ënner dësem Betrag ginn net veraffert. Schéckt keng aner Verméigensewäerter op dës Adress. Benotzt keng ICO- oder Crowdfunding-Adressen fir Ausbezuelungen.",
  "最小输入*": "Minimum {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "Déi minimal Ausbezuelquantitéit ass *. Ausbezuelkäschte ginn vum Ausbezuelbetrag ofgezunn. Iwwerpréift d'Empfängsadress suergfälteg. Schéckt keen * op Adressen ausserhalb vun *. Benotzt keng ICO- oder Crowdfunding-Adressen.",
  退出登录: "Ausloggen",
  加仓: "Positioun vergréisseren",
  新增仓位: "Nei Positioun",
  输入加仓金额: "Betrag fir Positiounsvergréisserung aginn",
  "当前可用:": "Aktuell disponibel:",
  资产账单: "Verméigensrechnung",
  保存二维码: "QR-Code späicheren",
  温馨提示: "Opgepasst",
  "请注意：您当前使用的网络": "Opgepasst: Dir benotzt de Moment dëst Netzwierk",
  输入提现地址: "Ausbezueladress aginn",
  "可用金额：": "Disponibel Betrag:",
  输入资产密码: "Verméigenspasswuert aginn",
  可用手续费: "Disponibel Transaktiounskäschten",
  "折扣%": "Rabatt %",
  实扣手续费: "Tatsächlech berechtegt Käschten",
  实际到账: "Tatsächlech kritt Betrag",
  未设置资产密码: "Kee Verméigenspasswuert agestallt",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "Setzt fir Är Sécherheet e Verméigenspasswuert ier Dir Ausbezuelunge maacht.",
  热榜: "Populär",
  涨幅榜: "Steiger",
  跌幅榜: "Faller",
  成交额榜: "Volumen Ranglëscht",
  关于我们: "Iwwer eis",
  登录密码: "Login Passwuert",
  设置: "Astellungen",
  资产密码: "Verméigenspasswuert",
  修改登录密码: "Login Passwuert änneren",
  原密码: "Aalt Passwuert",
  请输入新密码: "Neit Passwuert aginn",
  请输入原密码: "Aalt Passwuert aginn",
  确认密码: "Passwuert bestätegen",
  确定修改: "Ännerung bestätegen",
  修改资产密码: "Verméigenspasswuert änneren",
  验证码: "Verifikatiounscode",
  资产密码使用提示: "Verméigenspasswuert Tipps",
  "资产密码用于转移、提取资产和交易。":
    "Verméigenspasswuert gëtt benotzt fir Verméigen ze transferéieren, auszebezuelen an ze handelen.",
  "创建与登录密码不同的资产密码。":
    "Wielt e passwuert anescht wéi Äert Login Passwuert.",
  "定期更改您的资产密码。": "Änneret Äert Verméigenspasswuert regelméisseg.",
  提币历史: "Ausbezuelgeschicht",
  "金额/余额": "Betrag/Saldo",
  "手续费/折扣": "Käschte/Rabatt",
  自选: "Favoritten",
  现货: "Spot",
  市价: "Maartpräis",
  止损设置: "Stop-Loss Astellungen",
  合约K线图: "Futures Chart",
  "24H量": "24h Volumen",
  "24H额": "24h Volumen (USDT)",
  合作指南: "Partner Guide",
  盈亏计算: "Gewënn/Verloscht Berechnung",
  当前可用: "Aktuell disponibel",
  请输入加仓金额: "Betrag fir Positiounsvergréisserung aginn",
  请重新输入加仓金额:
    "Gitt de Betrag fir Positiounsvergréisserung nach eng Kéier an",
  平仓数量: "Zoumaache Quantitéit",
  欢迎登录: "Wëllkomm zeréck",
  "忘记密码?": "Passwuert vergiess?",
  "还没有账号？": "Nach kee Kont?",
  立即注册: "Elo registréieren",
  繁體中文: "Traditionellt Chineesesch",
  找回密码: "Passwuert erëmstellen",
  下一步: "Nächst",
  注册账户: "Kont registréieren",
  "请输入邀请码(选填)": "Invitatiounscode aginn (fakultativ)",
  谢邀豪礼: "Invitatiounsbonus",
  "24小时邀请好友排名": "24h Invitatiounslëscht",
  "*人": "* Leit",
  "差*人": "Nach * Leit néideg",
  "已超过10万人，每月轻松赚钱":
    "Méi wéi 100.000 Benotzer, verdéngt einfach all Mount",
  最高: "Maximum",
  邀请链接: "Invitatiounslink",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Deelt an den Transaktiounskäschten generéiert vun Äre Frënn (Spot, Futures, Margin, Schnellaustausch).",
  平台和您一起分享手续费: "Deelt an den Transaktiounskäschte mam Plattform",
  "*级": "* Niveau",
  规则: "Regelen",
  我的好友: "Meng Frënn",
  好友详情: "Frënd Detailer",
  获得好友佣金方案: "Frënd Kommissiounsplang",
  我的等级: "Meng Niveau",
  我的邀请数据: "Meng Invitatiounsstatistiken",
  当前等级: "Aktuelle Niveau",
  平台奖励您: "Plattform Belounung fir Iech",
  最高可获取平台奖励: "Maximal Plattform Belounung",
  邀请规则: "Invitatiounsregelen",
  "邀请*级有效好友": "Lued * Niveau aktiv Frënn an",
  好友等级: "Frënd Niveau",
  人: "Leit",
  奖金派送: "Bonus Ausbezuelung",
  平台奖励: "Plattform Belounung",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "D'Plattform huet d'Recht op Erklärung. Bei betrügereschen Aktivitéite ginn Belounungen ofgezunn an Äre Kont gëtt gefruer. Verluer Verméigen kann net erëmfonnt ginn.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Äre Kont muss aktiv sinn, definéiert als eng Depot vun op d'mannst * USDT am Wäert an all Krypto Wärung.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Ären ausgeluedene Frënd muss en aktiven Downline sinn, definéiert als eng Depot vun op d'mannst * USDT am Wäert.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Invitatiouns- a genodigte Kont däerfen net déi selwecht IP-Adress deelen.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "VIP-Niveau gëtt bestëmmt duerch d'Zuel vun ausgeluedene Frënn vum * Niveau.",
  佣金成分: "Kommissiounskomponenten",
  收益统计: "Rendement Statistiken",
  昨日收益: "Rendement vu gëschter",
  月收益: "Mount Rendement",
  获取收益: "Rendement kréien",
  "总收益：": "Gesamt Rendement:",
  "*级好友": "* Niveau Frënn",
  理财购买: "Finanzprodukt kafen",
  期限: "Lafzäit",
  可用金额: "Disponibel Betrag",
  预估收益: "Geschätzte Rendement",
  申购上限: "Maximum Kaf",
  项目剩余: "Rescht vum Projet",
  "买入后预计*(SGT)开始计算收益。":
    "Rendement fänkt virraussichtlech op *(SGT) no Kaf un.",
  计息日: "Rentestart Datum",
  申购日: "Kaf Datum",
  到账日: "Bezuelungsdatum",
  到期自动续投: "Automatesch reinvestéieren bei Verfall",
  申购: "Kafen",
  搜索理财项目: "Finanzproduit sichen",
  超高年化随心选: "Wielt tëscht Produite mat héijer Rent",
  "自由选择理财币种，稳定超额收益":
    "Wielt fräi Är Krypto Wärung fir stabil, iwwerschësseg Rendementer",
  理财总资产: "Total investéiert Verméigen",
  申购数量: "Ze kaf Quantitéit",
  立即购买: "Direkt kafen",
  年化收益率: "Jährlechen Zënssaz (APY)",
  理财订单: "Finanzproduit Bestellungen",
  持有: "Am Besëtz",
  申购份额: "Gekaafte Undeel",
  到账日期: "Bezuelungsdatum",
  申购成功: "Kaf erfollegräich",
  到期: "Verfall",
  是否选择做多: "Long goen?",
  "可用余额为0 不能操作": "Saldo ass 0, Aktioun net méiglech",
  福利中心: "Bonuszentrum",
  奖励记录: "Belounungsgeschicht",
  我获取到的奖励: "Meng verdéngte Belounungen",
  总价值: "Gesamt Wäert",
  新手任务: "Nei-Akommertasken",
  身份认证: "Identitéitsverifikatioun (KYC)",
  身份验证: "Identitéitsverifikatioun",
  去验证: "Elo verifizéieren",
  审核中: "Am Waarden",
  已验证: "Verifizéiert",
  认证失败: "Verifikatioun feelgeschloen",
  基础认证: "Basis Verifikatioun",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Opgepasst: Verifizéiert Informatioun kann net méi geännert ginn. Gitt korrekt Informatiounen un.",
  "国家/地区": "Land/Regioun",
  请选择: "Wielt",
  证件类型: "Dokumenttyp",
  证件编码: "Dokument Nummer",
  身份证: "Identitéitskaart",
  护照: "Pass",
  驾驶证: "Führerschäin",
  请输入编码: "Nummert aginn",
  名字: "Virnumm",
  请输入: "Aginn",
  中间名: "Mëttelnumm",
  选填: "Fakultativ",
  姓氏: "Familljennumm",
  中国: "China",
  身份上传: "Identitéitsdokument eroplueden",
  上传身份证: "Identitéitskaart eroplueden",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Eroplueden am JPG/JPEG/PNG-Format. Gitt sécher datt d'Biller kloer, komplett a mat gläichméisseger Beliichtung sinn. Maximum *MB.",
  确定提交: "Ofschécken",
  去认证: "Verifizéieren",
  挑战任务: "Erausfuerderungsaufgaben",
  注册认证任务: "Registréierungs- a Verifikatiounsaufgab",
  完成注册认证即可领取:
    "Schléisst d'Registréierung an d'Verifikatioun of fir ze kréien",
  领取奖励: "Belounung kréien",
  新人豪礼: "Welkom Bonus",
  "参与人数：": "Zuel vun Deelnehmer:",
  条件: "Konditioun",
  入金量: "Depot Betrag",
  完成: "Ofgeschloss",
  任务奖励: "Aufgab Belounung",
  距任务更新: "Bis Aufgab Update",
  "条件：": "Konditioun:",
  活动规则: "Aktiounsreegelen",
  奖励明细: "Belounungs Detailer",
  已获得: "Kritt",
  交易奖励: "Handelsbelounung",
  Win奖励: "WIN Belounung",
  已领取: "Kritt",
  亏损金额超过: "Verloschtbetrag iwwerschreift",
  单笔开仓金额超过: "Eenzele Bestellbetrag iwwerschreift",
  交易量: "Handelsvolumen",
  待完成: "Nach ze maachen",
  入金: "Deposéieren",
  盈利金额超过: "Gewënnbetrag iwwerschreift",
  开仓金额: "Bestellbetrag",
  开仓金: "Bestellbetrag",
  盈利: "Gewënn",
  亏损: "Verloscht",
  领取: "Kréien",
  未领取: "Net kritt",
  待领取: "Ze kréien",
  再交易: "Weider handelen",
  即可获得: "fir ze kréien",
  领取成功: "Erfollegräich kritt",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. All Aktivitéite ginn um Enn Datum verrechent. Belounungen verfalen duerno.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Verdéngte Rendement gëtt op Äre Bounty Kont gebucht, deen Dir ëmtauschen oder ausbezuele kënnt.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Belounungs Krypto Wärung hänkt vun der Aufgab of.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. D'Plattform huet d'Recht op Erklärung. Bei Betrug mat Aufgaben ginn Belounungen ofgezunn an Äre Kont kann gefruer ginn.",
  成长学院: "Akademie",
  "区块链 & 加密货币": "Blockchain & Krypto Wärung",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Äre komplette Guide fir Krypto Wärung. Mir féieren Iech op Ärer Krypto Rees.",
  "全仓合约定单的全部保证金。":
    "Total Marge fir Cross Marge Futures Bestellungen.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Saldo + (onrealiséierte Gewënn/Verloscht - Käschten - Finanzéierungszënssaz) = Netto Wäert / Benotzte Marge * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "Onrealiséierte Gewënn/Verloscht huet direkt Afloss op déi 'disponibel Marge'. Wann den onrealiséierte Gewënn/Verloscht eropgeet, geet déi disponibel Marge erop a vice versa.",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Saldo - (Benotzt Marge) + (onrealiséierte Gewënn/Verloscht - Käschten - Finanzéierungszënssaz)",
  "注:可继续用于开仓的保证金。":
    "Bemierkung: Marge déi disponibel ass fir nei Positiounen opzemaachen.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Saldo + (onrealiséierte Gewënn/Verloscht - Käschten - Finanzéierungszënssaz)",
  "注:当前的资金结余。": "Bemierkung: Aktuelle Saldo.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Bezitt sech op den Total Saldo vum Futures Kont, inklusiv blockéiert Verméigen.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Bemierkung: Wat méi héich de Risikoprozentsaz, wat méi niddreg de Risiko a vice versa.",
  该功能尚未开发: "Dës Funktioun ass nach an der Entwécklung",
  重置密码: "Passwuert zrécksetzen",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Gitt 8-20 Zeechen an, inklusiv Buschtawen, Zifferen a speziell Zeechen",
  修改成功: "Ännerung erfollegräich",
  输入验证码: "Verifikatiounscode aginn",
  输入密码: "Passwuert aginn",
  详情说明: "Detailer",
  已售罄: "Ausverkaaft",
  剩余期限: "Rescht Lafzäit",
  限期: "Lafzäit",
  闪兑货币选择: "Wielt Wärung fir schnellen Austausch",
  地区选择: "Regioun wielen",
  "搜索国家/地区": "Sich Land/Regioun",
  "身份信息已提交，将在*小时内审核完成":
    "Identitéitsinformatiounen ofgeschéckt. Veraffung dauert bis * Stonnen.",
  "选择国家/地区": "Wielt Land/Regioun",
  "止盈价格需高于*": "Take-Profit Präis muss méi héich sinn wéi *",
  "止损价格需低于*": "Stop-Loss Präis muss méi niddreg sinn wéi *",
  "止盈价格需低于*": "Take-Profit Präis muss méi niddreg sinn wéi *",
  "止损价格需高于*": "Stop-Loss Präis muss méi héich sinn wéi *",
  教程详情: "Tutorial Detailer",
  请输入止损价: "Stop-Loss Präis aginn",
  活期: "Flexibel",
  赎回后立即到账: "Sofort Ausbezuelung no Réckkaaf",
  赎回: "Réckkaafen",
  赎回理财: "Finanzproduit réckkaafen",
  是否赎回当前的理财订单: "Aktuelle Finanzbestellung réckkaafen?",
  维护: "Ënnerhalt",
  "系统正在维护中……": "System am Ënnerhalt...",
  合约: "Futures",
  闪电兑换: "Schnellen Austausch",
  流水挖矿: "Volume Mining",
  邀请豪礼: "Invitatiounsbonus",
  计算器: "Rechner",
  最新价: "Leschte Präis",
  涨跌幅: "Verännerung (24h)",
  关注币种添加自选: "Krypto Wärung zu Favoritten derbäisetzen",
  一键添加自选: "Zu Favoritten derbäisetzen (een Klick)",
  全标已读: "All als gelies markéieren",
  无消息: "Keng Norichten",
  "暂时还没有收到任何消息通知哦!": "Nach keng Notifikatiounen kritt!",
  没有更多数据: "Keng weider Daten",
  闪兑: "Schnellen Austausch",
  从: "Vun",
  "可用余额：": "Disponibel Saldo:",
  至: "Op",
  预览兑换结果: "Kuckt Austauschresultat",
  闪兑规则: "Regele fir schnellen Austausch",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "Schnellen Austausch ass ënner Maartschwankungen. Den tatsächlech kritt Betrag ass leedend.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "Wisselkoerse gi vun Drëttubidder bestëmmt. Duerch Käschten a Schwankungen kann de Kurs vum Maartkurs ofwäichen. Iwwerpréift suergfälteg.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "D'Plattform berechent ongeféier *% Käschte pro Austausch fir d'Käschte op Exchangen ze decken.",
  确认汇兑: "Austausch bestätegen",
  您预估得到: "Geschätzte Kritt",
  汇兑: "Austausch",
  汇兑比例: "Wisselkoers",
  刷新: "Erfrëschen",
  兑换: "Austauschen",
  没有更多了: "Keng weider Daten",
  搜索币种: "Sich Krypto Wärung",
  可用: "Disponibel",
  我知道了: "Ech hunn et verstan",
  最新价格: "Leschte Präis",
  确认: "Bestätegen",
  最大: "Maximum",
  "风险率(%)": "Risikoprozentsaz (%)",
  当前委托: "Aktuell Bestellungen",
  合作交易历史记录: "Partner Transaktiounsgeschicht",
  重置: "Zrécksetzen",
  余额: "Saldo",
  现货账户: "Spot Kont",
  合约账户: "Futures Kont",
  WIN账户: "WIN Kont",
  赏金账户: "Bounty Kont",
  总资产折合: "Total Verméigen (an USDT)",
  今日收益: "Rendement haut",
  充币: "Deposéieren",
  提币: "Ausbezuelen",
  账户权益: "Kont Wäert",
  "数量/类别": "Quantitéit/Kategorie",
  全部币种: "All Krypto Wärungen",
  全部类型: "All Typen",
  账单信息: "Rechnungsinformatiounen",
  理财赎回: "Finanzproduit Réckkaaf",
  购买理财: "Finanzproduit kafen",
  收入: "Akommes",
  支出: "Ausgaben",
  到: "op",
  资产划转: "Verméigen transferéieren",
  "最少*": "Minimum *",
  "可用资产：": "Disponibel Verméigen:",
  确认划转: "Transfert bestätegen",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Dir musst Verméigen op de richtege Kont transferéieren fir ze handelen. Transfere tëscht Konten si gratis.",
  币种账户选择: "Wielt Krypto Wärung Kont",
  选择账户: "Wielt Kont",
  划转详情: "Transfert Detailer",
  划转明细: "Transfert Spezifikatiounen",
  收入账单: "Akommensrechnung",
  支出账单: "Ausgaberechnung",
  金额: "Betrag",
  总收益: "Gesamt Rendement",
  佣金: "Kommissioun",
  用户名: "Benotzernumm",
  "已领取：": "Kritt:",
  "未领取：": "Net kritt:",
  "请选择国家/地区": "Wielt Land/Regioun",
  请上传身份信息: "Luet Identitéitsinformatiounen erop",
  请选择证件类型: "Wielt Dokumenttyp",
  请填写证件编码: "Gitt Dokumentnummer an",
  请填写名字: "Gitt Virnumm an",
  请填写姓氏: "Gitt Familljennumm an",
  投资金额: "Investitiounsbetrag",
  天: "Deeg",
  请输入手机号: "Gitt Mobil Nummer an",
  搜索: "Sichen",
  搜索历史: "Sichgeschicht",
  热门推荐: "Populär Empfehlungen",
  "《Xspace Earn协议》": "Xspace Earn Protokoll",
  我已了解并同意: "Ech hunn et verstan an akzeptéiert d'",
  协议: "Protokoll",
  Xspace官方中文交流群: "Xspace offiziell Chinesesch Gemeinschaft",
  Xspace官方英文交流群: "Xspace offiziell Englesch Gemeinschaft",
  预计维护至: "Erwaart Ënnerhalt bis",
  更多功能: "Méi Funktiounen",
  下载APP: "App eroflueden",
  理财: "Finanzproduit",
  推荐: "Empfohlen",
  Telegram官方中文频道: "Offiziellen Telegram Kanal (Chinesesch)",
  Telegram官方英文频道: "Offiziellen Telegram Kanal (Englesch)",
  官方邮箱: "Offiziell E-Mail Adress",
  客服邮箱: "Clientë Service E-Mail Adress",
  上述信息最终解释权归官方所有:
    "Déi uewe genannten Informatiounen ënnerleien der offizieller Erklärung vun der Plattform.",
  IOS版下载: "Eroflueden fir iOS",
  Android版下载: "Eroflueden fir Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Transaktiounskäschten = Akaafskäschten + Finanzéierungszënssaz + Verkaafskäschten",
  资金划转: "Verméigen transferéieren",
  止盈: "Take-Profit",
  止损: "Stop-Loss",
  自动平仓: "Automatesch zoumaachen",
  委托挂单: "Opp Bestellung",
  买: "Kafen",
  卖: "Verkafen",
  "买入/做多": "Kafen/Long",
  "卖出/做空": "Verkafen/Short",
  详情: "Detailer",
  浮动涨跌: "Onrealiséierte Gewënn/Verloscht",
  最小: "Minimum",
  充币数量: "Ze deposéieren Quantitéit",
  请输入充币数量: "Depositounsquantitéit aginn",
  支付截图: "Bezuelbeweis",
  提交: "Ofschécken",
  上传驾驶证: "Führerschäin eroplueden",
  上传护照: "Pass eroplueden",
  加载中: "Lueden...",
  上传成功: "Eroplueden erfollegräich",
  充值历史: "Depositounsgeschicht",
  合约卖出手续费: "Futures Verkaafskäschten",
  合约买入手续费: "Futures Akaafskäschten",
  系统加款: "System Guttbuchung",
  系统减款: "System Belastung",
  合约资金费率: "Futures Finanzéierungszënssaz",
  佣金分成: "Kommissiounsdeelung",
  U本位合约: "USDT-marginéiert Futures",
  资产管理: "Verméigens Gestioun",
  APP下载: "App eroflueden",
  全球领先的数字理财平台: "Weltwäit féierend digital Finanzplattform",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Handelt direkt Bitcoin, Ethereum an honnerte aner digital Verméigensewäerter",
  "24H涨跌幅": "24h Verännerung",
  查看更多行情: "Kuckt méi Mäert",
  近24小时成交量: "24h Volumen",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Bitt honnerte vu Spot- a Futures-Paaren. Méi wéi 20 Millioune Benotzer an 200+ Länner. Eng weltwäit féierend digital Verméigens Plattform.",
  用户国家分布: "Benotzer pro Land",
  用户数: "Zuel vu Benotzer",
  交易对: "Handelspaaren",
  服务支持: "Ënnerstëtzung",
  "随时随地，多平台终端交易":
    "Handelt iwwerall mat Multi-Plattform Ënnerstëtzung",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Perfekt kompatibel mat multiple Apparater fir all Handelsbesoinen.",
  随时查看实时行情: "Kuckt Echtzäit Coursen ëmmer an iwwerall",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Kaaft a verkaaft einfach BTC, ETH, DOGE an aner digital Verméigensewäerter",
  获取您关注的加密货币价格变化预警:
    "Kritt Präiswarnunge fir Krypto Wärungen déi Dir verfollegt",
  "查看比特币现货、期货、期权价格":
    "Kuckt Bitcoin Spot-, Futures- an Optiounspräisser",
  比较各交易所加密货币价格: "Vergläicht Krypto Wärungspräisser iwwer Exchangen",
  开启您的数字货币之旅: "Start Är digital Verméigensrees",
  快捷购买数字货币: "Kaaft séier Krypto Wärungen",
  "使用多种支付方式交易数字货币，安全快捷":
    "Handelt sécher a séier mat multiple Bezuelmethoden",
  最优的交易费率: "Déi bescht Transaktiounskäschten",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Virdeeler Tariffer, kompetitiv VIP-Virdeeler a Service vun Topqualitéit.",
  可信赖的安全保障: "Zouverlässeg Sécherheet",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Fortgeschratt Sécherheetsmoossnamen an de SAFU-Fonds schützen Är Verméigen géint Risiken.",
  交易: "Handelen",
  币币市场: "Spot Maart",
  "24H成交量": "24h Volumen",
  交易所: "Exchange",
  "24H最高": "24h Héichst",
  "24H最低": "24h Déifst",
  永续合约: "Perpetual Futures",
  日涨跌: "Deeglech Verännerung",
  交易深度: "Orderbuch Déift",
  "资产(合约)": "Verméigen (Futures)",
  历史仓位: "Positiounsgeschicht",
  兑换记录: "Austauschgeschicht",
  类型: "Typ",
  充值记录: "Depositounsgeschicht",
  划转记录: "Transfertgeschicht",
  类别: "Kategorie",
  历史账单: "Rechnungsgeschicht",
  在线充值: "Online Deposéieren",
  安全设置: "Sécherheetsastellungen",
  用于账户登录使用: "Gëtt fir Kont Login benotzt",
  用户提现时安全验证使用:
    "Gëtt fir Sécherheetsverifikatioun bei Ausbezuelunge benotzt",
  验证: "Verifizéieren",
  万: "Million",
  随时随地开启交易: "Start handelen ëmmer an iwwerall",
  "*货币交易所的所有功能尽在你的手中。":
    "All Funktiounen vun der * Krypto Exchange an Ärer Hand.",
  "下载*货币交易所APP。": "Luet d'* Krypto Exchange App erof.",
  下载自: "Eroflueden vun",
  内测版: "Beta Versioun",
  下载: "Eroflueden",
  扫码下载: "Scan fir erofzelueden",
  设置您的资产密码: "Setzt Äert Verméigenspasswuert",
  法币: "Fiat",
  我要买: "Ech wëll kafen",
  我要卖: "Ech wëll verkafen",
  请输入金额: "Betrag aginn",
  汇率: "Wisselkoers",
  获得: "Kritt",
  支付通道: "Bezuelkanal",
  收款通道: "Empfankskanal",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Gitt sécher datt den Empfankskanal op Ären eegenen Numm ass beim Verkaf.",
  当前法币暂不支持交易对可尝试前往提现:
    "Dëst Fiat Paar gëtt momentan net ënnerstëtzt. Probéiert eng Ausbezuelung.",
  前往提现: "Gitt op Ausbezuelen",
  该法币暂无通道: "Kee verfügbare Kanal fir dës Fiat",
  "正在出售中，请耐心等待": "Verkaf am Gaang, w.e.g. Gedold",
  请选择支付通道: "Wielt Bezuelkanal",
  请选择方式: "Wielt Method",
  法币历史: "Fiat Geschicht",
  买币: "Krypto kafen",
  卖币: "Krypto verkafen",
  失败: "Feelgeschloen",
  已完成: "Ofgeschloss",
  未付款: "Onbezuelt",
  待审核: "Am Waarden",
  打款中: "Ausbezuelung am Gaang",
  订单详情: "Bestell Detailer",
  联系客服: "Kontaktéiert Clientë Service",
  到账金额: "Kritt Betrag",
  通道: "Kanal",
  收款人: "Empfänger",
  收款账户: "Empfängskont",
  "订单出售失败，请查下方失败原因":
    "Verkafsbestellung feelgeschloen. Kuckt hei ënnen fir de Grond.",
  失败原因: "Grond fir Feelschloen",
  您还未进行付款: "Dir hutt nach net bezuelt",
  您已成功购买: "Kaf erfollegräich",
  已取消订单: "Bestellung annuléiert",
  "订单正在审核中，请耐心等待": "Bestellung am Prozess. W.e.g. Gedold.",
  您已成功出售: "Verkaf erfollegräich",
  "订单正在打款中，请耐心等待": "Ausbezuelung am Gaang. W.e.g. Gedold.",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "Fir d'Bezuelung musst Dir eng aner Plattform besichen. Passt op Är Informatiounssécherheet op.",
  当前法币暂不支持交易对可尝试前往充值:
    "Dëst Fiat Paar gëtt momentan net ënnerstëtzt. Probéiert eng Depositoun.",
  前往充值: "Gitt op Deposéieren",
  购买: "Kafen",
  订单号: "Bestellnummer",
  单价: "Stéckpräis",
  到账数量: "Kritt Quantitéit",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Et gëtt eng onbezuelt Bestellung. Nei Bezuelbestellung starten?",
  继续支付: "Weider bezuelen",
  重新下单: "Nei Bestellung opginn",
  是否确定出售: "Sidd Dir sécher datt Dir wëllt verkafen?",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "No der Bestätegung weist d'Plattform e Keefer zou. Waart op d'Matchmaking.",
  出售: "Verkafen",
  收款方式: "Empfanksmethod",
  订单已生成: "Bestellung generéiert",
  取消订单: "Bestellung annuléieren",
  请在: "W.e.g. bannent",
  内完成付款: "bezuelen",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Verloosst d'Plattform, loggt Iech op Är gewielte Bezuelmethod an a maacht d'Bezuelung op de folgende Kont vum Verkeefer. Gitt ëmmer d'Referenz un:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Ouni Referenz kann de Verkeefer d'Bezuelung net bestätegen, wat zu Verloscht vu Verméigen féiere kann.",
  "未在规定的时间内付款，订单都将被取消。":
    "Wann Dir net bannent der gesater Zäit bezuelt, gëtt d'Bestellung annuléiert.",
  姓名: "Numm",
  收款姓名: "Numm Empfänger",
  开户支行: "Bankfilial",
  银行卡号: "Bankkaart Nummer",
  "付款后，返回本平台": "Gitt no der Bezuelung op dës Plattform zréck",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "Klickt op de Knäppchen 'Ech hunn bezuelt, mellt Verkeefer'",
  未点击卖家不会放款:
    "De Verkeefer gëtt d'Krypto fräi nodeems Dir op de Knäppchen geklickt hutt",
  交易条款: "Transaktiounsbedingunge",
  "购买资金来源，必须合法安全的资金，方可交易":
    "D'Mëttel fir de Kaf mussen legal a sécher sinn",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Betrug, Pyramidennetzwierker, Glécksspill oder aner illegal Mëttel sinn net erlaabt",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Wann nom Transaktioun d'Suen afrueren oder verdächteg sinn, ginn mir d'USDT net fräi a ginn eng Réckerstattung",
  "已付款，通知卖家": "Bezuelt, mellt Verkeefer",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Wann Dir haut am Ganzen * Bestellungen annuléiert, gëtt Äert Kaafrecht fir haut zréckgezunn. Dës Bestellung annuléieren?",
  添加收款方式: "Empfanksmethod derbäisetzen",
  是否删除此收款方式: "Dës Empfanksmethod läschen?",
  删除: "Läschen",
  请选择法币: "Wielt Fiat Wärung",
  机构名称: "Numm vun der Institutioun",
  请选择机构: "Wielt Institutioun",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Är gewielte Empfanksmethod gëtt u Keefer gewisen wann Dir Krypto verkaaft. Kontrolléiert datt d'Donnéeën richteg sinn.",
  请选择银行: "Wielt Bank",
  请输入姓名: "Gitt Numm an",
  账号: "Kontonummer",
  请输入账号: "Gitt Kontonummer an",
  收款码: "Empfangscode",
  "银行账号/卡号": "Bankkonto/Kaartnummer",
  "请输入银行账号/卡号": "Gitt Bankkonto/Kaartnummer an",
  "开户支行（选填）": "Bankfilial (fakultativ)",
  请输入开户支行: "Gitt Bankfilial an",
  "加入*官方频道": "Gitt Member vum offizielle * Kanal",
  关于: "Iwwer",
  条款: "Konditiounen",
  成功: "Erfollegräich",
  等待: "Waarden",
  作废: "Ongülteg",
  确认付款: "Bezuelung bestätegen",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Bezuelung ofgeschloss? No der Bestätegung kontrolléiert de Verkeefer d'Rezeptioun bannent * Minutten.",
  最大金额: "Maximum Betrag",
  最小金额: "Minimum Betrag",
  付款: "Bezuelen",
  法币充值: "Fiat deposéieren",
  法币提现: "Fiat ausbezuelen",
  待支付: "Ze bezuelen",
  已支付: "Bezuelt",
  商户名: "Verkeefernumm",
  当前没有添加支付方式: "Keng Bezuelmethod derbäigesat",
  添加后再出售: "Setz eng derbäi ier Dir verkaaft",
  新人大礼包: "Welkomspak",
  注册即可领取: "Kritt no Registréierung",
  立即领取: "Elo kréien",
  不再提示: "Net méi weisen",
  "该奖励需在APP中领取，请下载APP":
    "Dës Belounung kann nëmmen an der App gekritt ginn. Luet d'App erof.",
  去交易: "Gitt handelen",
  期权交易: "Optiounshandel",
  交易额: "Handelsbetrag",
  可用额度: "Disponibel Limit",
  交易周期: "Handelsperiod",
  看涨: "Hausse (Call)",
  看跌: "Baisse (Put)",
  看空: "Short",
  当前持有: "Aktuell Positioun",
  胜率: "Gewënnquote",
  "盈利/亏损数": "Zuel vu Gewënn/Verloscht Transaktiounen",
  累计实现盈亏: "Realiséierten Total Gewënn/Verloscht",
  秒: "Sekonnen",
  分: "Minutten",
  小时: "Stonnen",
  周: "Woch",
  下单时间: "Bestellzäit",
  剩余时间: "Reschtzäit",
  买入价: "Akaafspräis",
  结算价: "Ofrechnungspräis",
  实现盈利: "Realiséierte Gewënn",
  结算时间: "Ofrechnungszäit",
  期权: "Optioun",
  新手教程: "Guide fir Ufänger",
  我的订单: "Meng Bestellungen",
  赔率: "Quote",
  全部订单: "All Bestellungen",
  持有订单: "Opp Bestellungen",
  历史订单: "Bestellgeschicht",
  输入交易额度: "Handelsbetrag aginn",
  选择交易周期: "Handelsperiod wielen",
  去注册: "Registréieren",
  冻结: "Afréieren",
  期权支出: "Optiounsausgab",
  期权收入: "Optiounsakommes",
  用户提现: "Benotzer Ausbezuelung",
  "是否购买？": "Dës Optioun kafen?",
  购买成功: "Kaf erfollegräich",
  请签名: "W.e.g. ënnerschreiwen",
  提交签名: "Ënnerschrëft ofginn",
  清空签名: "Ënnerschrëft läschen",
  签名审核中: "Ënnerschrëft am Waarden",
  已提交: "Ofginn",
  扫一扫下载APP: "Scan fir d'App erofzelueden",
  新手领取大礼包: "Ufänger Welkomspak",
  注册实名即送彩金: "Registréiert a verifizéiert fir Bonus ze kréien",
  交易总额: "Total Handelsvolumen",
  资产不足: "Net genuch Verméigen",
  "Win账户的资产不足，可从资金账户划转至此账户":
    "Net genuch Verméigen op WIN Kont. Dir kënnt Verméigen vun Ärem Haaptkont transferéieren.",
  Win: "WIN",
  比赛: "Kompetitioun",
  未开始: "Net ugefaangen",
  赛程: "Zäitplang",
  赛果: "Resultat",
  已结束: "Ofgeschloss",
  让球: "Handicap",
  进球数: "Goler",
  大: "Iwwer",
  小: "Ënner",
  胜负平: "1X2 (Gewënn/Gläich/Verloscht)",
  和局: "Gläichspill",
  投注: "Asaz",
  下注金额: "Asazbetrag",
  下注: "Asaz maachen",
  阵容: "Opstellung",
  分析: "Analyse",
  输入下注金额: "Asazbetrag aginn",
  下注成功: "Asaz erfollegräich",
  投注记录: "Asazgeschicht",
  未结算: "Net verrechent",
  已结算: "Verrechent",
  流水: "Ëmsaz",
  输赢: "Gewënn/Verloscht",
  赛时: "Kompetitiounszäit",
  下注时间: "Asazzäit",
  足彩竞猜: "Fussball Wett",
  查看详情: "Detailer kucken",
  输: "Verloscht",
  赢: "Gewënn",
  主: "Heem",
  客: "Auswärts",
  主胜: "Heemgewënn",
  客胜: "Auswärtsgewënn",
  平: "Gläich",
  已延期: "Verspéit",
  账号异常: "Kont Anomalie",
  全场独赢: "Fulltime 1X2",
  全场让球: "Fulltime Handicap",
  全场大小: "Fulltime Iwwer/Ënner",
  总进球: "Total Goler",
  拍摄照片要求: "Foto Ufuerderungen",
  标准拍摄: "Standard Foto",
  边框缺失: "Rand feelt",
  照片模糊: "Foto onscharf",
  闪光强烈: "Blëtz ze staark",
  上传手持证件照: "Luet Foto mat Dokument an der Hand erop",
  上传证件照: "Luet Dokumentfoto erop",
  换一张: "Nei Foto",
  出生日期: "Gebuertsdatum",
  请选择出生日期: "Wielt Gebuertsdatum",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Gitt déi ënnescht Verifikatiounscode an fir eng E-Mail Code ze kréien fir ze registréieren.",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Dir hutt nach * Verifikatiounsversich. Duerno kënnt Dir net méi verifizéieren.",
  上半场: "1. Halschent",
  下半场: "2. Halschent",
  独赢: "1X2",
  上半场独赢: "1. Halschent 1X2",
  下半场独赢: "2. Halschent 1X2",
  上半场让球: "1. Halschent Handicap",
  下半场让球: "2. Halschent Handicap",
  上半场大小球: "1. Halschent Iwwer/Ënner",
  下半场大小球: "2. Halschent Iwwer/Ënner",
  波胆: "Korrekte Score",
  上半场波胆: "1. Halschent Korrekte Score",
  下半场波胆: "2. Halschent Korrekte Score",
  单双: "Gerued/Onuerd",
  单: "Onuerd",
  双: "Gerued",
  上半场单双: "1. Halschent Gerued/Onuerd",
  下半场单双: "2. Halschent Gerued/Onuerd",
  上半场总进球: "1. Halschent Total Goler",
  下半场总进球: "2. Halschent Total Goler",
  中场: "Hallefzäit",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Opgepasst: Fir d'Foto mam Dokument an der Hand schreift den Text op e wäiss Blat Pabeier a fotograféiert dëst zesumme mat Ärem Dokument, wéi am Beispill.",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Et goufen rezent vill betrügeresch Konten bestrooft. Kontaktéiert de Clientë Service wann Dir mengt datt Äre Kont zu Unrecht bestrooft gouf.",
  最小下注金额: "Minimum Asaz",
  参与活动最小下注金额: "Minimum Asaz fir un der Aktioun deelzehuelen",
  记住密码: "Passwuert erënneren",
  比分: "Score",
  "您还未登录，请先登录": "Dir sidd net ageloggt. Loggt Iech fir d'éischt an.",
  立即登录: "Direkt aloggen",
  下注限额: "Asazlimit",
  可赢金额: "Ze gewannen Betrag",
  闪兑详情: "Detailer vum schnellen Austausch",
  大小球: "Iwwer/Ënner",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "Wéinst Wisselkoersschwankungen kann den endgültegen Asazbetrag ofwäichen. D'Bestellung ass leedend.",
  开赛时间: "Ufankszäit",
  足球收入: "Fussball Akommes",
  足球支出: "Fussball Ausgaben",
  活动详情: "Aktiounsdetailer",
  为世界杯喝彩: "Ënnerstëtzt d'Weltmeeschterschaft",
  我的竞猜: "Meng Tipps",
  "竞猜比赛、有机会瓜分*USDT":
    "Tippt op Spiller a maacht Chanc op en Deel vu * USDT",
  "瓜分*USDT": "Deelt * USDT",
  距离活动结束还有: "Nach bis Enn vun der Aktioun:",
  我的门票: "Meng Ticketten",
  竞猜结束时间: "Enn vun den Tippzäiten",
  猜比分: "Tippt de Score",
  "福利派送中，完成任务即可获取门票":
    "Boni ginn ausgedeelt. Komplettéiert Aufgaben fir Ticketten ze verdéngen.",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Komplettéiert déi ënnescht Aufgaben fir déi entspriechend Zuel u Ticketten fir un der Kompetitioun deelzehuelen.",
  时: "Stonn",
  活动: "Aktioun",
  竞猜记录: "Tippgeschicht",
  结果: "Resultat",
  任务: "Aufgab",
  去邀请: "Alueden",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Tippt de Score vun all Spill a maacht Chanc op en Deel vu $*.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "E Ticket ass néideg fir ze tippen. Ticketten kënne verdéngt ginn andeems Dir Plattformaufgaben ofschléisst.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的资金账户，你可以立即提取。":
    "Schéckt no engem erfollegräichen Tipp e Screenshot un de Clientë Service. Si wäerten de Bonus op Äre Kont iwwerweisen, deen Dir direkt ausbezuele kënnt.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Betrug ass verbueden. Bei Feststellung verfält d'Belounung.",
  "完成任务后，点击咨询客服获得门票。":
    "Klickt no der Kompletioun vun den Aufgaben op 'Kontaktéiert Clientë Service' fir Ticketten ze kréien.",
  继续猜: "Weider tippen",
  总单数: "Total Zuel vun Wetten",
  赛事筛选: "Filter op Evenement",
  球队筛选: "Filter op Team",
  总金额: "Total Betrag",
  总流水: "Total Ëmsaz",
  派奖金额: "Ausbezuelt Bonusbetrag",
  下注单数: "Zuel vun Wetten",
  利润: "Gewënn",
  更多福利: "Méi Boni",
  我的奖金: "Mäi Bonus",
  未认证: "Net verifizéiert",
  总量: "Total",
  或: "oder",
  模拟交易: "Demo Handel",
  体验账户不可操作: "Net disponibel op Demo Kont",
  世界杯比分竞猜: "Weltmeeschterschaft Score Tipp",
  "领*USDT起": "Kritt ab * USDT",
  消息: "Norichten",
  滚球: "Live Wetten",
  是: "Jo",
  不是: "Nee",
  当前余额: "Aktuelle Saldo",
  KOL招募: "KOL Rekrutéierung",
  本月净输赢: "Netto Gewënn/Verloscht dëse Mount",
  本月佣金: "Kommissioun dëse Mount",
  佣金比例: "Kommissiounsprozent",
  活跃人数: "Aktiv Benotzer",
  新增下级: "Nei Downlines",
  登录人数: "Ageloggte Benotzer",
  首存人数: "Éischt Depositoun Benotzer",
  数据分析: "Dateanalyse",
  人数: "Zuel vu Leit",
  新注册存款金额: "Depotbetrag nei Registréierungen",
  老用户存款金额: "Depotbetrag existent Benotzer",
  首存金额: "Éischt Depotbetrag",
  快捷入口: "Schnelle Zougang",
  成员管理: "Membere Gestioun",
  财务报表: "Finanziell Rapporten",
  分红报表: "Dividend Rapport",
  订单记录: "Bestellgeschicht",
  VIP专享: "VIP Exklusiv",
  推广工具: "Promotiounsinstrumenter",
  计算规则: "Berechnungsreegelen",
  账变明细: "Transaktiounsdetailer",
  成员: "Memberen",
  下级概览: "Iwwersiicht Downlines",
  下级成员总计: "Total Downlines",
  本月新增: "Dëse Mount nei",
  本月活跃会员: "Aktiv Memberen dëse Mount",
  今日活跃会员: "Aktiv Memberen haut",
  本月有效活跃: "Effektiv aktiv dëse Mount",
  活跃成员占比: "Prozentsaz aktiv Memberen",
  本月活跃: "Aktiv dëse Mount",
  今日活跃: "Aktiv haut",
  下级成员: "Downlines",
  会员账号: "Member Kont",
  统计时间: "Statistikszeit",
  筛选: "Filteren",
  存款: "Depot",
  取款: "Ausbezuelung",
  总输赢: "Total Gewënn/Verloscht",
  是否有效用户: "Aktiv Benotzer?",
  最近登录时间: "Leschte Login",
  否: "Nee",
  开始时间: "Startzäit",
  结束时间: "Endzäit",
  提取: "Ausbezuelen",
  总盈亏: "Total Resultat",
  净盈亏: "Netto Resultat",
  分红: "Dividend",
  概览: "Iwwersiicht",
  月度详细数据: "Mountlech Detailer",
  未发放: "Net ausbezuelt",
  活跃用户: "Aktiv Benotzer",
  有效新增会员: "Effektiv nei Memberen",
  冲正后净输赢: "Netto Gewënn/Verloscht no Korrektur",
  上月结余: "Saldo leschte Mount",
  净输赢: "Netto Gewënn/Verloscht",
  "系统每日新加坡时间1:00更新一次报表":
    "Rapporten ginn all Dag um 01:00 Auer Singapur Zäit aktualiséiert.",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "An de Rapporten heescht positiv Zuelen Gewënn fir de Partner, negativ Zuelen Verloscht fir de Partner.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Kommissiounsdate ginn all Dag aktualiséiert, sinn indikativ a stellen keng definitiv Ausbezuelsbasis duer.",
  选择时间: "Wielt Zäit",
  足球: "Fussball",
  投注金额: "Asazbetrag",
  有效订单: "Gülteg Bestellungen",
  下级账户: "Downline Kont",
  待成交: "Am Waarden",
  下单金额: "Bestellbetrag",
  订单内容: "Bestellinhalt",
  秒数: "Sekonnen",
  联赛: "Liga",
  队伍: "Team",
  比赛时间: "Spillzäit",
  玩法: "Wett Typ",
  等级规则表: "Niveau Reegelen Dësch",
  等级: "Niveau",
  活跃会员: "Aktiv Memberen",
  最新活跃: "Leschte Aktivitéit",
  额外佣金: "Extra Kommissioun",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "All Mount baséiert op Wuesstumsnormen. Et kann nëmme vun engem Niveau profitéiert ginn.",
  渠道生成: "Kanal generéieren",
  创建: "Erstellen",
  渠道名称: "Kanal Numm",
  注册人数: "Zuel vu Registréierungen",
  浏览人数: "Zuel vu Visiten",
  构建状态: "Bau Status",
  禁用: "Ausschalten",
  启用: "Aschalten",
  查看: "Kucken",
  创建渠道: "Kanal erstellen",
  创建成功: "Erstelle gelongen",
  操作成功: "Aktioun gelongen",
  渠道详情: "Kanal Detailer",
  邀请码: "Invitatiounscode",
  访问人数: "Zuel vu Visiten",
  渠道地址: "Kanal Adress",
  我的福利: "Meng Boni",
  充值福利: "Depositounsbonus",
  当前流水: "Aktuelle Ëmsaz",
  如何参与: "Wéi deelhuelen",
  币种充值: "Krypto Wärung Depot",
  充值福利中领取福利: "Claim Bonus bei Depositounsbonus",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Regel: Depositounsbonus ass fräiwëlleg, gülteg fir 24 Stonnen no Depot. No Claim gëtt Ausbezuelung temporär gespaart bis d'Ëmsaz Ufuerderung erreecht ass.",
  失效日期: "Verfallsdatum",
  "暂无福利领取，充值后领取": "Kee Bonus verfügbar. Claim no Depot.",
  参与: "Deelhuelen",
  充值赠送: "Depositounsbonus",
  "领取*%的赠送": "Claim *% Bonus",
  去领取: "Claimen",
  VIP奖励: "VIP Belounung",
  "当前可领取*USDT，是否确认领取":
    "* USDT verfügbar fir ze claimen. Bestätegen?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "No Claim gëtt Ausbezuelung temporär gespaart bis en Ëmsaz vu * USDT erreecht ass.",
  充值送大礼: "Depositounscadeau",
  "存入越多，送越多！": "Wat Dir méi deposéiert, wat méi grouss d'Cadeau!",
  无效: "Ongülteg",
  有效: "Gülteg",
  总存金额: "Total depositoune Betrag",
  提示: "Hiweis",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Positiv Zuelen am Total an Netto Gewënn/Verloscht bedeiten Plattformgewënn. Déi deeglech Donnéeë sinn indikativ.",
  "净盈亏：总盈亏-用户返水":
    "Netto Resultat: Total Resultat - Cashback un Benotzer",
  盈利方: "Gewënn Partei",
  代理: "Agent",
  客户: "Client",
  平局: "Gläichspill",
  平台: "Plattform",
  "已提交审核，请耐心等待": "Zur Verifikatioun agereecht. W.e.g. Gedold.",
  充值日期: "Depositounsdatum",
  平台本月总输赢: "Plattform Total Gewënn/Verloscht dëse Mount",
  KOL招募合作: "KOL Rekrutéierung Zesummenaarbecht",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "D'Plattform mécht d'KOL-Rekrutéierung op. Mat engem Social Media Account kënnt Dir vu Dividend a liewenslaange Kommissioune profitéieren duerch eemolege Client Werving.",
  级别: "Niveau",
  平台利润返佣: "Plattform Gewënn Kommissioun",
  佣金案例: "Kommissioun Beispill",
  交易项目: "Handelsprodukter",
  "期权交易、合约交易、足球游戏":
    "Optiounshandel, Futureshandel, Fussballspiller",
  报名方式: "Umeldungsmethod",
  点击KOL招募报名: "Klickt fir Iech fir KOL-Rekrutéierung unzemellen",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Wëllkomm an eisem Team. Mir ënnerstëtzen Iech beim Opbau vun Ärem eegene Benotzersystem. Verdéngt bis zu *% Kommissioun. Mir freeën eis op Är Participatioun.",
  输入联系方式: "Gitt Kontaktdetailer an",
  最低活跃人数: "Minimum Zuel vun aktive Benotzer",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "Z.B.: Wann aktiv Benotzer dëse Mount ≥ * a Plattform Total Gewënn/Verloscht ≥ * USDT, fällt Dir ënner Niveau * a kritt *% Kommissioun.",
  比分竞猜: "Score Tipp",
  豪礼相赠: "Grousst Cadeau",
  足球活动: "Fussball Aktioun",
  圣诞节活动: "Chrëschtdags Aktioun",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Dir hutt un enger Aktioun deelgeholl. Ausbezuelung ass temporär gespaart. Nach * USDT Ëmsaz néideg fir ze deblockéieren.",
  剩余流水: "Rescht Ëmsaz",
  助力足球: "Ënnerstëtzt Fussball",
  佣金累计: "Kommissioun Total",
  有效投注: "Gülteg Asaz",
  今日: "Haut",
  今日返水: "Cashback haut",
  VIP返水: "VIP Cashback",
  返水记录: "Cashback Geschicht",
  成员信息: "Member Informatiounen",
  基本信息: "Basis Informatiounen",
  钱包余额: "Portemonnaie Saldo",
  投注信息: "Asaz Informatiounen",
  返水: "Cashback",
  总下注: "Total Asaz",
  今日输赢: "Gewënn/Verloscht haut",
  下注动态: "Asaz Aktivitéit",
  返水奖励: "Cashback Belounung",
  分红金额: "Dividend Betrag",
  返水支出: "Cashback Ausgab",
  总返水: "Total Cashback",
  流水总额: "Total Ëmsaz",
  返水总额: "Total Cashback",
  返水详情: "Cashback Detailer",
  日流水: "Deeglechen Ëmsaz",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "Plattform gëtt extra Cashback op Basis vum deeglechen Ëmsaz vun Ären Downlines. Ausbezuelung all Dag um 00:00 Auer Singapur Zäit op Bounty Kont.",
  "申请成功，等待审核": "Ufro erfollegräich, am Waarden op Verifikatioun",
  "我出本金，盈利共分享": "Ech ginn Kapital, Gewënn gëtt gedeelt",
  最高分红: "Maximum Dividend",
  投资大师比赛: "Master Investor Kompetitioun",
  "我出本金，你盈利": "Ech ginn Kapital, du gewënns",
  共分享: "Zesummen deelen",
  最高分红可得: "Maximum erreechbar Dividend",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Exklusive Welkom Bonus: $* gratis. No Claim kënnt Dir an all Projet investéieren. Gewënn ass direkt ausbezuelbar.",
  报名领取: "Umellen a claimen",
  审核驳回: "Verifikatioun ofgeleent",
  驳回原因: "Grond fir Ofleenung",
  活动运行周期: "Aktiounsdauer",
  "申请成功后起至*天内完成超额收益。":
    "Bannent * Deeg no Genehmegung iwwerschësseg Rendement erreechen.",
  分红比: "Dividend Ratio",
  "*日获得盈利后，可获得*%的收益额。":
    "No Erreeche vum Gewënn op Dag *, kritt Dir *% vum Rendementsbetrag.",
  参与条件: "Deelnahmebedingunge",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Benotzer aus Russland oder Tierkei déi nach net virdru deelgeholl hunn.",
  计算项目: "Berechent Produkter",
  "合约、体育、期权": "Futures, Sport, Optiounen",
  我的投资: "Meng Investitiounen",
  参与天数: "Deelnahmezäit (Deeg)",
  累计下注: "Total Asaz",
  累计盈亏: "Total Gewënn/Verloscht",
  预计可分红: "Erwaart Dividend",
  常见问题: "Heefeg gestallte Froen (FAQ)",
  什么是平台出资: "Wat ass Plattformfinanzéierung?",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "D'Plattform stellt gratis Fongen zur Verfügung fir Benotzer aus spezifesche Länner fir a Projeten ze investéieren.",
  怎么获取平台出资的福利: "Wéi kréien ech d'Plattformfinanzéierungsbonus?",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Wann Dir aus engem vun den designéierte Länner sidd, klickt op den Umeldungsknäppchen. No Genehmegung ginn * USDT op Äre Bounty Kont iwwerwise, deen Dir ka transferéieren fir ze investéieren.",
  什么是分红: "Wat ass Dividend?",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Dividend: Wann bannent der gesater Zäit d'Rendement 100% erreecht, kritt Dir 50% vum iwwerschëssege Rendement. Z.B.: Kritt 100 USDT, erreecht 120% Rendement, dann ass 20% iwwerschësseg.",
  "如何取得分红？": "Wéi kréien ech Dividend?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "Den Aktiounszyklus ass all * Deeg. No Ofschloss gëtt verrechent. Bei Erfëlle vun de Viraussetzunge gëtt Dividend op de Bounty Kont gescheckt. Wann net erfëllt, ginn Äert Rendement an d'Plattformfinanzéierung geläscht.",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Deelhuelend Konten mussen KYC-verifizéiert sinn. Nëmmen eng Bonus pro Kont.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "KYC fir Participatioun ass nëmme gëlteg fir designéiert Länner. Kontrolléiert ob Äert Land mam Aktiounsland iwwerenee stëmmt.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "No erfollegräicher Participatioun gëtt Ausbezuelung temporär gespaart bis d'Aktioun ofgeschloss ass.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Hal Iech un d'Aktiounsreegelen. Bei Betrug oder Mëssbrauch vu Systemfeeler ginn all Verméigen op Ärem Kont permanent gefruer.",
  平台出资: "Plattformfinanzéierung",
  平台出资收回: "Plattformfinanzéierung zréckgeholl",
  投资大师奖励: "Master Investor Belounung",
  请下载APP添加收款方式:
    "Luet d'App erof fir eng Empfanksmethod derbäizesetzen",
  请下载APP进行身份验证: "Luet d'App erof fir Identitéitsverifikatioun",
  请下载APP参与: "Luet d'App erof fir deelzehuelen",
  技术指标: "Technesch Indicateuren",
  主图: "Haaptchart",
  副图: "Niewenchart",
  新注册人数: "Nei Registréierungen",
  老用户存款人数: "Existent Benotzer déi deposéieren",
  存款人数: "Zuel vun Depoten",
  取款人数: "Zuel vun Ausbezuelungen",
  投注人数: "Zuel vun Asätz",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Exklusiv Benotzer aus Indonesien, Indien, Bangladesch déi nach net virdru deelgeholl hunn.",
  市场动态: "Maartdynamik",
  外汇合约: "Forex Futures",
  盈亏比: "Gewënn/Verloscht Ratio",
  委托价: "Bestellpräis",
  可用余额: "Disponibel Saldo",
  持仓额: "Positiounswäert",
  强平价: "Liquidatiounspräis",
  修改: "Änneren",
  修改价位: "Präis änneren",
  外汇: "Forex",
  外汇账户: "Forex Kont",
  我的交易: "Meng Transaktiounen",
  未设置: "Net agestallt",
  超出最大可设数值: "Iwwerschreift maximal astellbare Wäert",
  超出最小可设数值: "Ënnerschreift minimal astellbare Wäert",
  止盈超出最小可设数值: "Take-Profit ënnerschreift minimal astellbare Wäert",
  止损超出最大可设数值: "Stop-Loss iwwerschreift maximal astellbare Wäert",
  止盈超出最大可设数值: "Take-Profit iwwerschreift maximal astellbare Wäert",
  止损超出最小可设数值: "Stop-Loss ënnerschreift minimal astellbare Wäert",
  挖矿: "Mining",
  交易账户: "Handelskont",
  买涨: "Kafen (Long)",
  买跌: "Verkafen (Short)",
  请输入正确的银行卡信息: "Gitt korrekt Bankkaart Detailer an",
  联系在线客服: "Kontaktéiert Live Clientë Service",
  法币交易请联系在线客服:
    "Kontaktéiert w.e.g. de Clientë Service fir Fiat Handel",
  提交订单: "Bestellung ofschécken",
  "支付过程如有疑问,请联系在线客服":
    "Kontaktéiert w.e.g. de Clientë Service bei Froen iwwer de Bezuelprozess",
  彩金赠送: "Bonus Ausbezuelung",
  在线客服: "Live Chat",
  最少投资: "Minimum Investitioun",
  "提交时间:": "Agabezäit:",
  提现拒绝: "Ausbezuelung refuséiert",
  认证拒绝: "Verifikatioun refuséiert",
  认证通过: "Verifikatioun akzeptéiert",
  请输入正确的交易额度: "Gitt e gültegen Handelsbetrag an",
  最大下注金额: "Maximum Asaz",
  手机号: "Mobil Nummer",
  邮箱注册: "Mat E-Mail registréieren",
  手机号注册: "Mat Mobil Nummer registréieren",
  查询: "Nokucken",
  手机号登录: "Mat Mobil Nummer aloggen",
  邮箱登录: "Mat E-Mail aloggen",
  请输入数量: "Gitt Quantitéit an",
  可用数量: "Disponibel Quantitéit",
  钱包登录: "Mat Wallet aloggen",
  请输入正确的邀请码: "Gitt e gültegen Invitatiounscode an",
  "请输入邀请码(必填)": "Gitt Invitatiounscode an (verpflichtend)",
  输入正确的金额: "Gitt e gültege Betrag an",
  法币充值: "Fiat deposéieren",
  卢比充值: "Indesch Rupie (INR) deposéieren",
  请输入法币: "Gitt Fiat Betrag an",
  请输入IFSC: "Gitt IFSC Code an",
  "银行编码(选填)": "Bank Code (fakultativ)",
  请输入银行编码: "Gitt Bank Code an",
  请输入大于8位数的密码: "Gitt e Passwuert mat méi wéi 8 Zeechen an",
  添加成功: "Derbäisetzen erfollegräich",
  "60秒": "60 Sekonnen",
  "180秒": "180 Sekonnen",
  "300秒": "300 Sekonnen",
  "2次密码不一致": "Passwierder stëmmen net iwwereneen",
  输入提币数量: "Gitt Ausbezuelquantitéit an",
  图片格式不正确: "Ongülteg Bildformat",
  图片大于20M: "Bild ass méi grouss wéi 20MB",
  请设置委托价格: "Setzt e Bestellpräis",
  输入资金密码: "Gitt Verméigenspasswuert an",
  验证码错误: "Verifikatiounscode falsch",
  充值拒绝: "Depositoun refuséiert",
  请输入SSN: "Gitt SSN an",
  结算完成: "Ofrechnung ofgeschloss",
  继续下单: "Weider bestellen",
  限价: "Limit Order",
  买入价格: "Akaafspräis",
  买入量: "Ze kafen Quantitéit",
  卖出价格: "Verkaafspräis",
  卖出量: "Ze verkafen Quantitéit",
  买入: "Kafen",
  卖出: "Verkafen",
  订单创建成功: "Bestellung erfollegräich erstallt",
  币币买入支出: "Ausgab Spot Kaf",
  币币买入支出退还: "Réckerstattung Ausgab Spot Kaf",
  币币买入获得: "Kritt Spot Kaf",
  币币卖出支出: "Ausgab Spot Verkaf",
  币币卖出支出退还: "Réckerstattung Ausgab Spot Verkaf",
  币币卖出获得: "Kritt Spot Verkaf",
  币币交易手续费: "Spot Transaktiounskäschten",
  请输入限价: "Gitt Limit Präis an",
  成交: "Ausgefouert",
  等待成交: "Am Waarden op Ausféierung",
  交易完成: "Transaktioun ofgeschloss",
  被取消: "Annuléiert",
  交易时间: "Transaktiounszäit",
  法币交易: "Fiat Handel",
  法币出售: "Fiat Verkaf",

  两次密码不一致: "Passwierder stëmmen net iwwereneen",
  再次输入账户密码: "Gitt d'Kontpasswuert nach eng Kéier an",

  美国: "Vereenegt Staaten",
  韩国: "Südkorea",
  阿尔巴尼亚: "Albanien",
  津巴布韦: "Simbabwe",
  赞比亚: "Sambia",
  也门: "Jemen",
  美属维尔京群岛: "Amerikanesch Joffereninselen",
  英属处女群岛: "Brittesch Joffereninselen",
  越南: "Vietnam",
  委内瑞拉: "Venezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Usbekistan",
  乌拉圭: "Uruguay",
  英国: "Vereenegt Kinnekräich",
  阿拉伯联合酋长国: "Vereenegt Arabesch Emirater",
  乌克兰: "Ukrain",
  乌干达: "Uganda",
  特克斯和凯科斯群岛: "Turks- a Caicosinselen",
  土库曼斯坦: "Turkmenistan",
  土耳其: "Tierkei",
  突尼斯: "Tunesien",
  特立尼达和多巴哥: "Trinidad an Tobago",
  汤加: "Tonga",
  多哥: "Togo",
  东帝汶: "Osttimor",
  泰国: "Thailand",
  坦桑尼亚: "Tansania",
  塔吉克斯坦: "Tadschikistan",
  中国台湾: "Taiwan",
  叙利亚: "Syrien",
  瑞士: "Schwäiz",
  瑞典: "Schweden",
  斯威士兰: "Swasiland",
  苏里南: "Suriname",
  苏丹: "Sudan",
  斯里兰卡: "Sri Lanka",
  西班牙: "Spanien",
  南非: "Südafrika",
  索马里: "Somalia",
  所罗门群岛: "Salomonen",
  斯洛文尼亚: "Slowenien",
  斯洛伐克: "Slowakei",
  "圣马丁岛（荷兰部分）": "Sint Maarten (hollänneschen Deel)",
  新加坡: "Singapur",
  塞拉利昂: "Sierra Leone",
  塞舌尔: "Seychellen",
  塞尔维亚: "Serbien",
  塞内加尔: "Senegal",
  沙特阿拉伯: "Saudi-Arabien",
  圣多美和普林西比: "São Tomé a Príncipe",
  圣马力诺: "San Marino",
  萨摩亚: "Samoa",
  圣克里斯托弗和尼维斯: "St. Kitts an Nevis",
  圣文森特和格林纳丁斯: "St. Vincent an d'Grenadinnen",
  圣彼埃尔和密克隆岛: "St. Pierre a Miquelon",
  圣露西亚: "St. Lucia",
  圣基茨和尼维斯: "St. Kitts an Nevis",
  卢旺达: "Ruanda",
  俄罗斯: "Russland",
  罗马尼亚: "Rumänien",
  留尼汪: "Réunion",
  刚果共和国: "Republik Kongo",
  卡塔尔: "Katar",
  波多黎各: "Puerto Rico",
  葡萄牙: "Portugal",
  波兰: "Polen",
  菲律宾: "Philippinnen",
  秘鲁: "Peru",
  巴拉圭: "Paraguay",
  巴布亚新几内亚: "Papua-Neiguinea",
  巴拿马: "Panama",
  巴勒斯坦: "Palästina",
  帕劳: "Palau",
  巴基斯坦: "Pakistan",
  阿曼: "Oman",
  挪威: "Norwegen",
  尼日利亚: "Nigeria",
  尼日尔: "Niger",
  尼加拉瓜: "Nicaragua",
  新西兰: "Neiséiland",
  新喀里多尼亚: "Neikaledonien",
  荷属安德列斯群岛: "Hollännesch Antillen",
  荷兰: "Holland",
  尼泊尔: "Nepal",
  纳米比亚: "Namibia",
  缅甸: "Myanmar",
  莫桑比克: "Mosambik",
  摩洛哥: "Marokko",
  蒙特塞拉特岛: "Montserrat",
  黑山: "Montenegro",
  蒙古: "Mongolei",
  摩纳哥: "Monaco",
  摩尔多瓦: "Moldawien",
  墨西哥: "Mexiko",
  马约特: "Mayotte",
  毛里求斯: "Mauritius",
  毛里塔尼亚: "Mauretanien",
  马里亚纳群岛: "Marianen",
  马提尼克: "Martinique",
  马耳他: "Malta",
  马里: "Mali",
  马尔代夫: "Maldiven",
  马来西亚: "Malaysia",
  马拉维: "Malawi",
  马达加斯加: "Madagaskar",
  马其顿: "Nordmazedonien",
  中国澳门: "Macau",
  卢森堡: "Lëtzebuerg",
  立陶宛: "Litauen",
  列支敦士登: "Liechtenstein",
  利比亚: "Libyen",
  利比里亚: "Liberia",
  莱索托: "Lesotho",
  黎巴嫩: "Libanon",
  拉脱维亚: "Lettland",
  老挝: "Laos",
  吉尔吉斯斯坦: "Kirgisistan",
  科威特: "Kuwait",
  基里巴斯: "Kiribati",
  肯尼亚: "Kenia",
  哈萨克斯坦: "Kasachstan",
  约旦: "Jordanien",
  日本: "Japan",
  牙买加: "Jamaika",
  象牙海岸: "Côte d'Ivoire",
  意大利: "Italien",
  以色列: "Israel",
  爱尔兰: "Irland",
  伊拉克: "Irak",
  伊朗: "Iran",
  印度尼西亚: "Indonesien",
  印度: "Indien",
  冰岛: "Island",
  匈牙利: "Ungarn",
  中国香港: "Hongkong",
  洪都拉斯: "Honduras",
  海地: "Haiti",
  圭亚那: "Guyana",
  几内亚比绍共和国: "Guinea-Bissau",
  几内亚: "Guinea",
  危地马拉: "Guatemala",
  关岛: "Guam",
  瓜德罗普岛: "Guadeloupe",
  格林纳达: "Grenada",
  格陵兰岛: "Grönland",
  希腊: "Griicheland",
  直布罗陀: "Gibraltar",
  加纳: "Ghana",
  德国: "Däitschland",
  格鲁吉亚: "Georgien",
  冈比亚: "Gambia",
  加蓬: "Gabun",
  法属波利尼西亚: "Franséisch Polynesien",
  法属圭亚那: "Franséisch-Guayana",
  法国: "Frankräich",
  芬兰: "Finnland",
  斐济: "Fidschi",
  法罗群岛: "Färöer",
  埃塞俄比亚: "Ethiopien",
  爱沙尼亚: "Estland",
  厄立特里亚: "Eritrea",
  赤道几内亚: "Equatorialguinea",
  萨尔瓦多: "El Salvador",
  埃及: "Egypten",
  厄瓜多尔: "Ecuador",
  多米尼加共和国: "Dominikanesch Republik",
  多米尼加: "Dominica",
  吉布提: "Dschibuti",
  丹麦: "Dänemark",
  捷克: "Tschechien",
  塞浦路斯: "Zypern",
  库拉索: "Curaçao",
  古巴: "Kuba",
  克罗地亚: "Kroatien",
  哥斯达黎加: "Costa Rica",
  科特迪瓦: "Côte d'Ivoire",
  库克群岛: "Cookinselen",
  科摩罗: "Komoren",
  哥伦比亚: "Kolumbien",
  智利: "Chile",
  乍得: "Tschad",
  中非共和国: "Zentralafrikanesch Republik",
  佛得角: "Kap Verde",
  开曼群岛: "Kaimaninselen",
  开普: "Kap",
  加拿大: "Kanada",
  喀麦隆: "Kamerun",
  柬埔寨: "Kambodscha",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bulgarien",
  文莱: "Brunei",
  巴西: "Brasilien",
  博茨瓦纳: "Botswana",
  波斯尼亚和黑塞哥维那: "Bosnien an Herzegowina",
  玻利维亚: "Bolivien",
  不丹: "Bhutan",
  百慕大群岛: "Bermuda",
  贝宁: "Benin",
  伯利兹: "Belize",
  比利时: "Belsch",
  白俄罗斯: "Wäissrussland",
  巴巴多斯: "Barbados",
  孟加拉国: "Bangladesch",
  巴林: "Bahrain",
  巴哈马: "Bahamas",
  阿塞拜疆: "Aserbaidschan",
  奥地利: "Éisträich",
  澳大利亚: "Australien",
  阿鲁巴: "Aruba",
  亚美尼亚: "Armenien",
  阿根廷: "Argentinien",
  安提瓜和巴布达: "Antigua a Barbuda",
  安圭拉: "Anguilla",
  安哥拉: "Angola",
  安道尔: "Andorra",
  美属萨摩亚: "Amerikanesch-Samoa",
  阿尔及利亚: "Algerien",
  中国: "China",
  余额不足: "Net genuch Saldo",
  最低购买: "Minimum Kaf",
  最高购买: "Maximum Kaf",
  下单成功: "Bestellung erfollegräich opginn",
  平仓成功: "Positioun erfollegräich zougemaach",
  请输入正确的平仓数量: "Gitt eng gülteg Zoumaachungsquantitéit an",
  加仓成功: "Positiounsvergréisserung erfollegräich",
  请输入正确的加仓金额: "Gitt e gültege Betrag fir Positiounsvergréisserung an",
  收藏成功: "Zu Favoritten derbäigesat",
  取消收藏成功: "Aus Favoritten läschen erfollegräich",
  加密币永续: "Krypto Wärung Perpetual",
  外汇永续: "Forex Perpetual",
  期权账户: "Optiounskont",
  快捷卖币: "Schnell Krypto verkafen",

  托管资金: "Gestioun Verméigen",
  托管中: "Am Gestioun",
  预计日收益: "Geschätzten deegleche Rendement",
  累计收益: "Gesamt Rendement",
  周期: "Lafzäit",
  日收益: "Deegleche Rendement",
  限额: "Limit",
  立即托管: "Direkt Verméigen gestioun",
  "已鎖定 請聯繫客服": "Gesperrt. Kontaktéiert w.e.g. de Clientë Service.",
  产品列表: "Produktlëscht",
  规则: "Reegelen",
  创建订单: "Bestellung erstellen",
  产品名称: "Produktnumm",
  托管周期: "Gestiounsdauer",
  等级限制: "Niveau Limitatioun",
  托管金额: "Gestioun Betrag",
  限额: "Limit",
  余额: "Saldo",
  购买日: "Kaf Datum",
  起息日: "Rentestart Datum",
  派息时间: "Rent Ausbezuelungszäit",
  每天: "All Dag",
  计息结束日: "Rent Enn Datum",
  每日收益: "Deegleche Rendement",
  预计收益: "Geschätzte Rendement",
  "收益将自动发送至您的余额账户;":
    "Rendement gëtt automatesch op Äre Saldo geschéckt;",
  "您的资金没有任何风险;": "Äert Verméigen leeft kee Risiko;",
  "365*24小时不断地工作;": "Schafft 24/7, 365 Deeg am Joer;",
  托管中: "Am Gestioun",
  结束: "Ofgeschloss",
  今日收益: "Rendement haut",
  剩余周期: "Rescht Lafzäit",
  进行中: "Aktiv",
  已发放: "Ausbezuelt",
  信誉分: "Reputatioun Score",

  复制成功: "Erfollegräich kopéiert",
  VIP权益: "VIP-Virdeeler",
  旧密码: "Aalt Passwuert",
  请输入旧密码: "Gitt w.e.g. äert aalt Passwuert an",
  "忘记旧密码请联系客服重置。":
    "Wann Dir äert aalt Passwuert vergiess hutt, kontaktéiert w.e.g. de Clientsservice fir et zréckzesetzen.",
  去升级: "Upgraden",
  描述: "Beschreiwung",
  实际存款金额: "Aktuelle Depotbetrag",
  升级礼金: "Upgrade-Bonus",
  隔夜利息: "Iwwernuechtungszënssaz (Swap)",
  自动结算: "Automatesch Ofrechnung",
  等级规则: "Niveaureegelen",
  "WEB3.0币持有数据收益": "WEB3.0-Mënzhalte Datenausbezuelung",
  总生产: "Gesamtproduktioun",
  有效节点: "Aktiv Knuet",
  参与人: "Participanten",
  用户收益: "Benotzerausbezuelung",
  "流动性WEB3.0输出": "Liquiditéits-WEB3.0-Output",
  总资产: "Gesamtverméigen",
  ETHAI持有数据收益: "ETHAI Besëtz Daten Ausbezuelung",
  AI量化流动性: "AI quantitativ Liquiditéit",
  现货买入手续费: "Spot Kafsgebühr",
  现货支出: "Spot Ausgab",
  现货资金费率: "Spot Finanzéierungsquot",
  现货卖出手续费: "Spot Verkafsgebühr",
  现货收入: "Spot Akommes",
  外汇合约支出: "Währungscontrat Ausgab",
  外汇合约买入手续费: "Währungscontrat Kafsgebühr",
  外汇合约资金费率: "Währungscontrat Finanzéierungsquot",
  外汇合约卖出手续费: "Währungscontrat Verkafsgebühr",
  外汇合约收入: "Währungscontrat Akommes",
  理财购买: "Finanzprodukt Kaf",
  VIP理财日收益: "VIP Finanzprodukt deeglech Ausbezuelung",
  VIP理财隔夜利息: "VIP Finanzprodukt Iwwernuecht Zënsen",
  VIP本金返还: "VIP Réckbezuelung vum Kapital",
  VIP彩金发放: "VIP Bonus Ausbezuelung",
  VIP彩金抵扣: "VIP Bonus Ofzuch",
  隔夜利息: "Iwwernuecht Zënsen",
  设置资产密码: "Verméigens Passwuert setzen",

  锁仓挖矿: "Blockéiert Mining",
  一站式理财服务: "Alles-an-eent Finanzservicer",
  产品: "Produkter",
  客服中心: "Client Service Zentrum",
  贷款: "Prêten",
  挖矿赚不停: "Kontinuéierlech Akommes duerch Mining",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Blockéiert Mining bedeit, datt USDT (USD:1USDT=1USD) un héichleistungs Mining-Maschinne vun der Plattform uvertraut ginn, fir Akommes am Mining-Pool ze generéieren.",
  产品优势: "Virdeeler vum Produkt",
  随存随取: "Jiddereen Zäit deposéieren an ofhiewen",
  锁仓周期: "Blockéierungsperiod",
  每日下发: "Deeglech Ausbezuelung",
  随机空投: "Zoufälleg Airdrop",
  "100%资金安全保障": "100% Sécherheet vun de Fongen",
  "100%节假日收益不间断": "100% kontinuéierlech Akommes och op Feierdeeg",
  成功锁仓后当天产出:
    "Akommes fänkt de selwechten Dag no erfollegräicher Blockéierung un",
  关于违约金: "Iwwer Strofen",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Wann Dir d’Kapital virum Lafzäit ofhëlt, gëtt eng Strof berechent. Strof = Strofquote × Reschtdagen × blockéierte Betrag.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Beispill: D’Strofquote ass 5%, et bleiwen 3 Deeg, an de blockéierte Betrag ass 10000U (USDT/USD). Strof = 5%×3×10000=1500U, an de richteg zeréckbezuelte Betrag ass 15000U-1500U.",
  收益计算: "Akommesberechnung",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "D’Plattform bitt verschidde Finanzprodukter fir blockéiert Mining un. D’Akommesberechnung ass wéi follegt, zum Beispill:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Wann e Benotzer 10000U (USDT, USD) blockéiert a en 7-Deeg Produkt mat 0,7%~1,8% deeglechem Rendement wielt, ass d’Akommes pro Dag wéi follegt:",
  "最低:10000Ux0.7%=70U;": "Minimum: 10000U×0,7%=70U;",
  "最高:10000Ux1.8%=180U;": "Maximum: 10000U×1,8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "No 7 Deeg kënnen 490U~1260U u Gewënn erreecht ginn. D’Akommes gëtt deeglech ausgezahlt an de Kapital gëtt automatesch op Äre Kont transferéiert.",
  正在托管的资金: "Verwalte Fongen",
  签到: "Check-in",
  锁仓订单: "Blockéiert Bestellungen",
  预计今日收益: "Geschätzte Gewënn haut",
  累计收益: "Kumuléierte Gewënn",
  托管中的订单: "Bestellungen an der Verwaltung",
  单笔最少: "Minimum pro Bestellung",
  单笔最多: "Maximum pro Bestellung",
  日收益率: "Deeglech Rendement",
  说明: "Beschreiwung",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Statistike baséieren op GMT+8 Zäitzon<br>2. Deeglecht Akommes gëtt op Basis vun all ofgerechenten Bestellungen tëscht 00:00-23:59 GMT+8 berechent<br>3. D’Akommes gëtt den nächsten Dag tëscht 00:00-00:10 GMT+8 ausbezuelt.",
  知道了: "Verstanen",
  锁仓: "Blockéieren",
  派息时间: "Ausbezuelungszäit",
  每日: "Deeglech",
  托管资金: "Verwalt Fongen",
  到期返回: "Zréck bei Lafzäit Enn",
  提前赎回: "Fréi Ofhiewung",
  预计收益: "Geschätzte Gewënn",
  认购: "Abonnéieren",
  热门: "Populär",
  数字货币: "Kryptowährungen",
  贵金属: "Edelmetaller",
  大宗商品: "Wueremäert",
  持仓明细: "Positiounsdetailer",
  历史明细: "Historik",
  当前价: "Aktuelle Präis",
  "↑买涨": "↑ Opsteiger kafen",
  "↓买跌": "↓ Ofgang kafen",
  显示全部: "Alles weisen",
  买入金额: "Kafbetrag",
  方向: "Richtung",
  收益: "Gewënn",
  预期收益: "Erwaarte Gewënn",
  估用保证金: "Geschätzte Marge",
  确认下单: "Bestellung confirméieren",
  锁定: "Gespärt",
  账户总资产: "Gesamt Verméigen",
  明细: "Detailer",
  今日收益: "Gewënn haut",
  仓位保证金: "Positiounsmarge",
  持有仓位: "Gehalen Positiounen",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Blockéierte Betrag = Zomm vun all onofgeschlossene blockéierte Mining-Bestellungen",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Statistike baséieren op GMT+8<br>2. Deeglecht Akommes baséiert op ofgerechenten Bestellungen",
  充值方式: "Depotmethod",
  银行汇款: "Bankiwwerweisung",
  "银行汇款请联系客服进行操作!":
    "Kontaktéiert de Client Service fir Bankiwwerweisung!",
  提款方式: "Ofhiewungsmethod",
  "银行提款请联系客服进行操作!":
    "Kontaktéiert de Client Service fir Bankofhiewung!",
  资金明细: "Fongdetailer",
  提现记录: "Ofhiewungsrekord",
  拒绝: "Ofgeleent",
  通过: "Genehmegt",
  拒绝原因: "Grond fir Oflehnung",

  消息公告: "Ukënnegungen",
  订单: "Bestellungen",
  个人中心: "Perséinleche Beräich",
  "未到期赎回需支付一定的违约金!":
    "Bei virzäiteger Réckkaf muss eng Kontraktstrof bezuelt ginn.",

  请输入区号: "Gitt w.e.g. d’Virwahl an",
  "请选择国家/地区": "Gitt w.e.g. e Land/eeng Regioun un",

  今日开盘: "Haut Ouverture",
  昨日收盘: "Gëschter Schluss",

  实名认证即送: "Kritt et direkt no der Identitéitsverifikatioun",
  立即认证: "Elo verifizéieren",
  新用户礼包: "Geschenkpak fir nei Benotzer",
  完成新人任务领取: "Fëllt d'Aufgabe fir nei Benotzer of fir et ze kréien",
  认证: "Verifizéieren",
  时间周期: "Zäitraum",
  支付金额: "Bezuelungsbetrag",
  已平仓: "Ofgeschloss",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "MGBX Wëllkommenspak fir nei Benotzer: All Benotzer kann maximal kréien",
  我已经阅读并同意: "Ech hunn gelies an akzeptéieren",
  隐私政策: "Dateschutzpolitik",

  放弃奖励离开: "Belounung opginn a verloossen",
  继续注册: "Registréierung weiderféieren",
  分钟: "Minutten",

  "请先勾选隐私政策!": "Kuckt w.e.g. als éischt d'Dateschutzbestimmungen no!",

  添加其他到自选: "Anerer op d'Observatiounslëscht setzen",
  充值最高可得: "Lued op a kritt bis zu 30.000 $.",

  请输入格式正确的手机号: "Gitt w.e.g. eng gülteg Handysnummer an.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 卢森堡



// WEBPACK FOOTER //
// ./src/lang/lsb.js